import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

export default function LatestResult(props) {
    const { data } = props;
    const time = data.length > 0 ? data[data.length -1].name : null;
    const duration = data.length > 0 ? data[data.length -1].duration : null;
    return (
      <Typography
        component="p"
        variant="body2"
        align="right"
      >
        {duration} {props.unit}
      </Typography>
    )
}



// WEBPACK FOOTER //
// ./src/components/LatestResultTable.js